import {Component, Input} from '@angular/core';
import {ContentResponse} from "../../interface/contentResponse";
import {ContentType} from "../../interface/contentType";
import {DeleteContentComponent} from "../delete-content/delete-content.component";
import {ContentService} from "../../service/content.service";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {EditContentComponent} from "../edit-content/edit-content.component";
import {Router} from "@angular/router";
import {ConfigUtility} from "../../utilityClass/configUtility";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ContentUpdateRequest} from "../../interface/contentUpdateRequest";
import {DeleteProfileCardComponent} from "../../profile-card/delete-profile-card/delete-profile-card.component";
import {data} from "jquery";
import {DELETE_CONTENT_TITLE, DELETE_DESCRIPTION} from "../../constants/deleteProfileCards.constant";

@Component({
  selector: 'app-content-list',
  templateUrl: './content-list.component.html',
  styleUrl: './content-list.component.scss'
})
export class ContentListComponent {

  @Input() contentList: ContentResponse [] = []
  @Input() contentType: ContentType | any
  @Input() showMore: boolean | any

  dialogRef: MatDialogRef<DeleteProfileCardComponent> | undefined;
  dialogRefEdit: MatDialogRef<EditContentComponent> | undefined;

  content: ContentResponse | any
  contentIcon: string | any
  icon: string | any

  showGridList: boolean = false;
  clicked: boolean = false;

  itemsToShow: number = 12

  constructor(
    private contentService: ContentService,
    private router: Router,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {
  }

  getContentImage(image: string) {
    return this.contentService.getImage(image);
  }

  deleteContent(content: ContentResponse) {
    this.dialogRef = this.dialog.open(DeleteProfileCardComponent, {
      data: {
        deleteTitle: DELETE_CONTENT_TITLE,
        deleteDescription: DELETE_DESCRIPTION,
      }
    });
    this.dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.contentService.deleteContentById(content.id).subscribe(() => {
          const number = this.contentList.indexOf(content);
          if (number !== -1) {
            this.contentList.splice(number, 1);
          }
        })
      }
    })
  }

  openEditContent(contentId: bigint) {
      const dialogConfig= new MatDialogConfig();
      dialogConfig.data = {
        content: contentId
      }
      this.dialogRefEdit = this.dialog.open(EditContentComponent, dialogConfig);
      this.dialogRefEdit.afterClosed().subscribe((result: any) => {
        if (result) {
          if (result.updatedContent) {
            this.updateContent(result.updatedContent)
          }
          if (result.contentIcon) {
            this.icon = result.contentIcon
          }
        }
      });
  }

  toggleShowMore() {
    this.showMore = !this.showMore;
    this.itemsToShow = this.showMore ? this.contentList.length : 12;
  }

  private updateContent(updatedContent: ContentUpdateRequest) {
    this.contentService.updateContent(updatedContent.id, updatedContent).subscribe({
          next: () => {
            this.handleContentUpdateSuccess(updatedContent.id)
          },
          error: (error) =>  {
            this.handleErrorResponse(error)
          }
        }
    );
  }

  private handleContentUpdateSuccess(contentId: bigint) {
    if (this.icon) {
      this.uploadContentIcon(contentId, this.icon);
    } else {
      this.navigateToContentPage();
    }
  }

  private uploadContentIcon(contentId: bigint, newImageFile: File) {
    this.contentService.uploadContentIcon(contentId, newImageFile).subscribe({
      next: () => {
        this.navigateToContentPage()
      },
      error: (uploadError) => {
        this.handleErrorResponse(uploadError)
      }
    });
  }

  private navigateToContentPage() {
    this.contentService.updatedContent.emit()
    this.router.navigate(['/admin/page/links']);
  }

  private handleErrorResponse(error: any) {
    if (error.status === 404) {
      this.showSnackBar('Content not found.', 'error');
    } else if (error.status === 500) {
      this.showSnackBar('Internal server error.', 'error');
    } else {
      this.showSnackBar('An unexpected error occurred.', 'error');
    }
  }

  private showSnackBar(message: string, panelClass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: [panelClass]
    });
  }
}
